/* ==================================================
 *  Pagination
 *  ==================================================*/

(function () {

  'use strict';

  $(document).on('click', 'a[data-pagination]', function (ev) {
    if (!isTouchDevice()) {
      ev.preventDefault();

      var $this = $(this);
      var url = $this.attr('href');

      if (ev.originalEvent.ctrlKey || ev.originalEvent.metaKey) {
        return window.open(url);
      } else if (ev.originalEvent.shiftKey) {
        return window.open(
          url, null, 'height=' + $(window).height() + ',width=' + $(window).width());
      }

      $('body').addClass('loading');

      if (url) {
        window.location.href = url;
      }
    }
  });
})();
